/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShiftBidWithSchedule = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        scheduleId: {
    type: 'number',
    isRequired: true,
},
        bidder: {
    type: 'IdName',
    isRequired: true,
},
        status: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};